var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"z-tabs-label",class:_vm.classObject,attrs:{"href":`#${_vm.itemId}`},on:{"click":function($event){return _vm.toggleItem($event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }